<template>
  <div class="plDeratedContent" style="width:100%; padding-top: 60px" >
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%;background-color:#fff;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">
          办理
        </van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea"
                       placeholder="请输入审批说明"/>
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>

    <van-collapse v-model="activeNames">
      <van-collapse-item title="减免信息" name="1" v-if="inputForm.category == 1">
        <van-field label="项目名称" v-model="inputForm.projectName" input-align="left" :border="false" readonly autosize rows="1"
                   type="textarea"></van-field>
        <van-field label="客户名称" v-model="inputForm.customerName" input-align="left" :border="false" readonly></van-field>
        <van-field v-if="inputForm.serviceType == 1" label="申请房号" v-model="inputForm.houseName" input-align="left" :border="false" readonly autosize rows="1"
                   type="textarea"></van-field>
        <van-field v-if="inputForm.serviceType == 2" label="合同编号" v-model="inputForm.code" input-align="left" :border="false" readonly autosize rows="1"
                   type="textarea"></van-field>
        <van-field label="减免总额(元)" v-model="inputForm.amount" :formatter="formatter" input-align="left" :border="false" readonly></van-field>
        <van-field label="发起人" v-model="inputForm.createByName" input-align="left" :border="false" readonly></van-field>
        <van-field label="发起时间" v-model="inputForm.updateDate" input-align="left" :border="false" readonly></van-field>
        <van-field label="减免说明" v-model="inputForm.remarks" input-align="left" :border="false" readonly autosize rows="1"
                   type="textarea"></van-field>
<!--        <div style="padding-left: 16px;">-->
<!--          <p>附件</p>-->
<!--          <a style="display: block; color: #4caedc" v-for="(file, index) in inputForm.attachList" :key="index" :href="file.url">{{file.name}}</a>-->
<!--        </div>-->
        <div style="padding-left: 16px;" v-show="inputForm.attachList.length > 0">
          <p>附件</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
      </van-collapse-item>

      <van-collapse-item title="减免信息" name="1" v-if="inputForm.category == 2">
        <van-field label="项目名称" v-model="inputForm.projectName" input-align="left" :border="false" readonly autosize rows="1"
                   type="textarea"></van-field>
        <van-field label="减免事项" v-model="inputForm.deratedContent" input-align="left" :border="false" readonly autosize rows="1"
                   type="textarea"></van-field>
        <van-field label="收费项目名称" v-model="inputForm.feeItemName" input-align="left" :border="false" readonly autosize rows="1"
                   type="textarea"></van-field>
        <van-field label="收费标准名称" v-model="inputForm.feeNormName" input-align="left" :border="false" readonly autosize rows="1"
                   type="textarea"></van-field>
        <van-field label="计费开始时间" v-model="inputForm.sDate" input-align="left" :border="false" readonly></van-field>
        <van-field label="计费结束时间" v-model="inputForm.eDate" input-align="left" :border="false" readonly></van-field>
        <van-field label="调减单价(元)" v-model="inputForm.deratedUnitPrice" input-align="left" :border="false" readonly></van-field>
        <van-field label="调减户数" v-model="inputForm.houseNum" input-align="left" :border="false" readonly></van-field>
        <van-field label="减免总额(元)" v-model="inputForm.amount" input-align="left" :border="false" readonly></van-field>
        <van-field label="发起人" v-model="inputForm.createByName" input-align="left" :border="false" readonly></van-field>
        <van-field label="发起时间" v-model="inputForm.updateDate" input-align="left" :border="false" readonly></van-field>
        <van-field label="减免说明" v-model="inputForm.remarks" input-align="left" :border="false" readonly autosize rows="1"
                   type="textarea"></van-field>
      </van-collapse-item>
<!--      <div class="m-form" v-if="inputForm.category == 1">-->
<!--        <div class="title">减免信息</div>-->
<!--        <div class="m-row">-->
<!--          <div class="m-row-text">项目名称</div>-->
<!--          <div class="m-row-content">{{ inputForm.projectName }}</div>-->
<!--        </div>-->
<!--        <div class="m-row">-->
<!--          <div class="m-row-text">客户名称</div>-->
<!--          <div class="m-row-content">{{ inputForm.customerName }}</div>-->
<!--        </div>-->
<!--		<div class="m-row" v-if="inputForm.serviceType == 1">-->
<!--		  <div class="m-row-text">申请房号</div>-->
<!--		  <div class="m-row-content">{{ inputForm.houseName }}</div>-->
<!--		</div>-->
<!--		<div class="m-row" v-if="inputForm.serviceType == 2">-->
<!--		  <div class="m-row-text">合同编号</div>-->
<!--		  <div class="m-row-content">{{ inputForm.code }}</div>-->
<!--		</div>-->
<!--        <div class="m-row">-->
<!--          <div class="m-row-text">减免总额(元)</div>-->
<!--          <div class="m-row-content">{{ inputForm.amount.toFixed(2) }}</div>-->
<!--        </div>-->
<!--        <div class="m-row">-->
<!--          <div class="m-row-text">发起人</div>-->
<!--          <div class="m-row-content large-content">{{ inputForm.createByName }}</div>-->
<!--        </div>-->
<!--        <div class="m-row">-->
<!--          <div class="m-row-text">发起时间</div>-->
<!--          <div class="m-row-content large-content">{{ inputForm.updateDate }}</div>-->
<!--        </div>-->
<!--        <div class="m-row" style="border-bottom: 1px solid #eee">-->
<!--          <div class="m-row-text">减免说明</div>-->
<!--          <div class="m-row-content large-content">{{ inputForm.remarks }}</div>-->
<!--        </div>-->
<!--      </div>-->
	  
<!--	  <div class="m-form" v-if="inputForm.category == 2">-->
<!--	    <div class="title">减免信息</div>-->
<!--	    <div class="m-row">-->
<!--	      <div class="m-row-text">项目名称</div>-->
<!--	      <div class="m-row-content">{{ inputForm.projectName }}</div>-->
<!--	    </div>-->
<!--	    <div class="m-row">-->
<!--	      <div class="m-row-text">减免事项</div>-->
<!--	      <div class="m-row-content">{{ inputForm.deratedContent }}</div>-->
<!--	    </div>-->
<!--	    <div class="m-row">-->
<!--			<div class="m-row-text">收费项目名称</div>-->
<!--			<div class="m-row-content">{{ inputForm.feeItemName }}</div>-->
<!--	    </div>-->
<!--		<div class="m-row">-->
<!--			<div class="m-row-text">收费标准名称</div>-->
<!--			<div class="m-row-content">{{ inputForm.feeNormName }}</div>-->
<!--		</div>-->
<!--		<div class="m-row">-->
<!--			<div class="m-row-text">计费开始时间</div>-->
<!--			<div class="m-row-content">{{ inputForm.sDate }}</div>-->
<!--		</div>-->
<!--		<div class="m-row">-->
<!--			<div class="m-row-text">计费结束时间</div>-->
<!--			<div class="m-row-content">{{ inputForm.eDate }}</div>-->
<!--		</div>-->
<!--		<div class="m-row">-->
<!--			<div class="m-row-text">调减单价(元)</div>-->
<!--			<div class="m-row-content">{{ inputForm.deratedUnitPrice }}</div>-->
<!--		</div>-->
<!--		<div class="m-row">-->
<!--			<div class="m-row-text">调减户数</div>-->
<!--			<div class="m-row-content">{{ inputForm.houseNum }}</div>-->
<!--		</div>-->
<!--	    <div class="m-row">-->
<!--	      <div class="m-row-text">调减总额(元)</div>-->
<!--	      <div class="m-row-content">{{ inputForm.amount.toFixed(2) }}</div>-->
<!--	    </div>-->
<!--	    <div class="m-row">-->
<!--	      <div class="m-row-text">发起人</div>-->
<!--	      <div class="m-row-content large-content">{{ inputForm.createByName }}</div>-->
<!--	    </div>-->
<!--	    <div class="m-row">-->
<!--	      <div class="m-row-text">发起日期</div>-->
<!--	      <div class="m-row-content large-content">{{ inputForm.updateDate }}</div>-->
<!--	    </div>-->
<!--	    <div class="m-row" style="border-bottom: 1px solid #eee">-->
<!--	      <div class="m-row-text">减免说明</div>-->
<!--	      <div class="m-row-content large-content">{{ inputForm.remarks }}</div>-->
<!--	    </div>-->
<!--	  </div>-->

	  <div class="m-form">
	    <div class="m-row" style="height: 30px; line-height: 30px; border-bottom: 1px solid #eee; border-right: 1px solid #eee">
	      <a style="display: block; color: #4caedc" href="#" @click="view">查看明细</a>
	    </div>
	  </div>
<!--      <van-collapse-item name="2" title="附件信息">-->
<!--        <div class="m-row" v-for="(file, index) in inputForm.attachList" :key="index" style="height: 30px; line-height: 30px; border-bottom: 1px solid #eee; border-right: 1px solid #eee">-->
<!--          <a style="display: block;  color: #4caedc; margin-left: 16px; font-size: 14px;" :href="file.url">{{ file.name }}</a>-->
<!--        </div>-->
<!--      </van-collapse-item>-->
<!--      <div class="m-form" v-if="inputForm.attachList.length > 0">-->
<!--        <div class="title">附件信息</div>-->
<!--        <div class="m-row" v-for="(file, index) in inputForm.attachList" :key="index" style="height: 30px; line-height: 30px; border-bottom: 1px solid #eee; border-right: 1px solid #eee">-->
<!--          <a style="display: block;  color: #4caedc" :href="file.url">{{ file.name }}</a>-->
<!--        </div>-->
<!--      </div>-->
    </van-collapse>

    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import TaskService from '../../api/flowable/TaskService.js'
import ProcessService from '../../api/flowable/ProcessService'
import DeratedApplyService from "../../api/finance/DeratedApplyService";
import processRecord from "../../components/processRecord/processRecord";

export default {
  data() {
    return {
      activeNames: ['1'],
      isshow: false,
      radio: '',
      inputForm: {
		houseNum: 0,
        houseName: '',
        amount: '',
        remarks: '',
        attachList: [],
		category: '',
        isDoTask: false,
        isLastTask: false,
      },
      dataList: [],
      amounts: 0,
      deratedAmounts: 0,
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      businessId: '',
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: 100,
        orders: []
      },
      searchForm: {
        deratedId: ''
      },
      type: ''
    }
  },
  computed: {
    totalDeratedFee(){
      let temp = 0
      this.dataList.forEach(item => {
        temp += item.deratedAmount
      })
      return temp.toFixed(2)
    }
  },
  components: {
    processRecord
  },
  mounted() {
  },
  created() {
    let query = this.$route.query;
    this.businessId = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    // let id = this.$cookie.get('id')
    // this.taskId = this.$cookie.get('taskId')
    // this.taskDefKey = this.$cookie.get('taskDefKey')
    // this.procInsId = this.$cookie.get('procInsId')
    // this.procDefId = this.$cookie.get('procDefId')
	this.init(this.businessId)

  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
	view(){
		this.$router.push({
		    path: 'wuye_finance_derated_detail',
		    query: {
		        id: this.businessId
		    }
		})
	},
    init(id) {
		this.searchForm.deratedId = id
		new DeratedApplyService().queryById(id).then(({data}) => {
			this.inputForm = data
			this.inputForm.sDate = data.startDate
			this.inputForm.eDate = data.endDate
			this.inputForm.startDate = ''
			this.inputForm.endDate = ''
		})
    },
    close() {
      if(this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        vars = {...vars, ..._this.inputForm}
        // _this.auditForm.message = _this.inputForm.message
		_this.auditForm.type = _this.inputForm.isLastTask?'_flow_approval':'_flow_agree'

        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          businessTable: 'wuye_finance_derated',
          businessId: this.businessId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({data}) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = _this.inputForm.isLastTask ? 4 : 2;
          new DeratedApplyService().startFlow(_this.inputForm);

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({data}) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = 3;
          new DeratedApplyService().startFlow(_this.inputForm);

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    formatter(value){
      return Number(value).toFixed(2)
    }
  }
}
</script>

<style scoped>
	* {
	  margin: 0;
	  padding: 0;
	}
  
  .plDeratedContent {
    height: calc(100vh - 60px);
    background-color: #fff!important;
  }
	.m-form {
	  width: 100vw;
	  padding: 10px;
	  font-size: 12px;
	  box-sizing: border-box;
    background-color: #fff!important;
	}
	.title {
	  width: calc(100vw - 20px);
	  height: 30px;
	  background-color: #eeeeee;
	  line-height: 30px;
	  font-weight: bold;
	  padding-left: 5px;
	  box-sizing: border-box;
	/*// margin-bottom: 20rpx;*/
	}

	.m-row {
	  display: flex;
	  width: calc(100vw - 22px);
	  border: 1px solid #eee;
	  border-bottom: 0px;
	}

	.m-row-text {
	  width: 110px;
	  padding-left: 5px;
	  border-right: 1px solid #eee;
	  /*border-bottom: 1px solid #eee;*/
	  display: flex;
	  align-items: center;
	  /*background-color: #eee;*/
	}

	.m-row-content {
	  width: calc(100vw - 130px);
	  height: 30px;
	  line-height: 30px;
	  padding-left: 10px;
	}

	.large-content {
	  width: calc(100vw - 130px);
	  min-height: 30px;
	  height: auto;
	  padding-left: 10px;
	  overflow: hidden;
	}

  .textColor {
    color: #d9d8d8!important;
  }
</style>
  